import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo_clan_guzzi.svg'


const _withScopeId = n => (_pushScopeId("data-v-bb58f07e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pageContainer bg_black profile" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "squareButton" }
const _hoisted_4 = {
  key: 0,
  class: "text-center mt-3"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "motoGuzziLogo mb-3"
}, null, -1))
const _hoisted_6 = { class: "white mb-1" }
const _hoisted_7 = { class: "fs_18 white d-block ln_21 mb-4" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "text-center mt-3"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "motoGuzziLogo mb-3"
}, null, -1))
const _hoisted_11 = { class: "white mb-1" }
const _hoisted_12 = { class: "fs_18 white d-block ln_21 mb-4" }
const _hoisted_13 = {
  class: "sameAsButton primaryButton w-75 mx-auto mb-3",
  href: "https://theclan.motoguzzi.com/il-tuo-profilo-fan",
  target: "blank"
}
const _hoisted_14 = { class: "text-center mt-5" }
const _hoisted_15 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_field = _resolveComponent("form-field")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_vue_qrcode = _resolveComponent("vue-qrcode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_form_field, {
          type: "select",
          list: _ctx.availableLanguages,
          modelValue: _ctx.selectedLanguage,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedLanguage) = $event)),
          showSearch: false,
          class: _normalizeClass([_ctx.selectedLanguage == 'it-IT' ? 'bigPadding' : 'smallPadding', "languageSelect"])
        }, null, 8, ["list", "modelValue", "class"])
      ])
    ]),
    (_ctx.loggedUser.isOwner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_TheClanOwner",
            text: "The Clan Owner",
            class: "fs_16 ln_24 red d-block mt-3 mb-3"
          }),
          _hoisted_5,
          _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.loggedUser.completeName), 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.loggedUser.username), 1),
          (_ctx.isGadgetDisponible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_vue_qrcode, {
                  value: _ctx.loggedUser.identifier,
                  options: {
                        color: {
                            dark: '#ffffff',
                            light: '#000000',
                        },
                    },
                  class: "qrcode"
                }, null, 8, ["value"]),
                _createVNode(_component_localized_text, {
                  localizedKey: "app_AssicuratidiritirareilWelcomeKit",
                  text: "Assicurati di ritirare il Welcome Kit al desk The Clan.",
                  class: "fs_16 ln_41 white d-block mb-4"
                })
              ]))
            : (_openBlock(), _createBlock(_component_localized_text, {
                key: 1,
                localizedKey: "app_WelcomeKitSoldOut",
                text: "Welcome Kit sold out",
                class: "fs_16 ln_41 white d-block mb-4"
              }))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_TheClanFan",
            text: "The Clan Fan",
            class: "fs_16 ln_24 red d-block mt-3 mb-3"
          }),
          _hoisted_10,
          _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.loggedUser.completeName), 1),
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.loggedUser.username), 1),
          _createVNode(_component_localized_text, {
            localizedKey: "app_SembrachetusiaregistratocomefanDiventaOwner",
            text: "Completa la registrazione come owner per ottenere il welcome kit!",
            class: "fs_16 ln_41 white d-block mb-4"
          }),
          _createVNode(_component_localized_text, {
            localizedKey: "Tieniaportatadimanoidati",
            text: "Tieni a portata di mano i dati</br> di immatricolazione</br> della tuo Moto Guzzi",
            class: "fs_16 mb-4 d-block white text-center"
          }),
          _createElementVNode("a", _hoisted_13, [
            _createVNode(_component_localized_text, {
              localizedKey: "app_DiventaOwner",
              text: "Diventa Owner",
              class: "fs_16 d-block white"
            })
          ])
        ])),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_localized_text, {
        localizedKey: "app_ScopriilprogrammadiOpenHouse2024",
        text: "Scopri il programma di Open House 2024 su:",
        class: "fs_14 ln_21 white d-block mb-2"
      }),
      _createElementVNode("a", {
        href: _ctx.motoguzziSiteLinkLocalized,
        target: "_blank",
        class: "w-75 mx-auto red text-decoration-underline"
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_www.motoguzzi.com",
          text: "www.motoguzzi.com"
        })
      ], 8, _hoisted_15)
    ]),
    _createElementVNode("button", {
      class: "secondaryButton w-75 mx-auto mb-3 mt-5 logoutButton",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logout()))
    }, [
      _createVNode(_component_localized_text, {
        localizedKey: "app_Logout",
        text: "Logout"
      })
    ])
  ]))
}